import * as monaco from 'monaco-editor';
import {
  ProtocolConnection,
  SemanticTokensRequest,
  ServerCapabilities,
} from 'vscode-languageserver-protocol';

import { semanticTokensMapper } from '../utils/convertVscodeToMonaco';

export function semanticTokensProvider(
  languageId: string,
  connection: ProtocolConnection,
  semanticTokensOptions: ServerCapabilities['semanticTokensProvider'],
) {
  if (semanticTokensOptions === undefined) return;

  const {
    legend,
    // TODO: do we want to do anything with these?
    // range,
    // full,
    // workDoneProgress,
  } = semanticTokensOptions;
  if ('documentSelector' in semanticTokensOptions) {
    // TODO: do we want to do anything with these?
    // const { documentSelector, id } = semanticTokensProvider;
  }

  monaco.languages.registerDocumentSemanticTokensProvider(languageId, {
    getLegend: () => ({
      tokenTypes: legend.tokenTypes,
      tokenModifiers: legend.tokenModifiers,
    }),
    async provideDocumentSemanticTokens(model, _, token) {
      const result = await connection.sendRequest(
        SemanticTokensRequest.type,
        {
          textDocument: { uri: model.uri.toString(true) },
        },
        token,
      );

      if (token.isCancellationRequested || !result) {
        return null;
      }

      return semanticTokensMapper.vscodeToMonaco(result);
    },
    async releaseDocumentSemanticTokens() {
      // no-op
    },
    onDidChange: undefined,
  });
}
